export default __webpack_public_path__ + "static/media/foodieBooster08.ea5ef070.png";